(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["discover-teas"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    $('.teas-slider').slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: true,
      adaptiveHeight: true,
      dots: false,
      prevArrow: $('.custom-slider-arrows .prev-arrow'),
      nextArrow: $('.custom-slider-arrows .next-arrow'),
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["holiday-imgtxt-slider"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
    $('.holiday-imgtxt-content-wrapper').slick({
      dots: false,
      arrows: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true, 
      // autoplay: true,
      // autoplaySpeed: 3000,
      adaptiveHeight: true,
      prevArrow:
        '<img class="slick-prev" src="https://cdn.shopify.com/s/files/1/0648/5580/2077/files/Previous.png?v=1760160377" alt="Previous">',
      nextArrow:
        '<img class="slick-next" src="https://cdn.shopify.com/s/files/1/0648/5580/2077/files/Next_1.png?v=1760160377" alt="Next">',
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  
  
  
  
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }
  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;

            const recommendations = html.querySelector('[grid-recommendation]');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.querySelector('[grid-recommendation]').innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tea-tour-gallery"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function(){
  var itemsToShow = 4; // how many to show each click
  var $items = $('.gallery-item');
  var $button = $('.load-more');

  $button.on('click', function(){
    var hiddenItems = $items.filter('.hidden').slice(0, itemsToShow);
    
    hiddenItems.each(function(i, el){
      setTimeout(function(){
        $(el).removeClass('hidden').addClass('fade-in');
      }, i * 150); // staggered animation
    });

    // hide button if no more hidden items
    if($items.filter('.hidden').length === 0){
      $button.hide();
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
